import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';

import{ArticleService} from '../../services/article.service';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-masquerade',
  templateUrl: './masquerade.component.html',
  styleUrls: ['./masquerade.component.css']
})
export class MasqueradeComponent implements OnInit {
  userName='';
	navigationsType=[];

  url:any=AppSettings.API_ENDPOINT;

	type_articles:any=[];

	msg:any;

	toastr:any;

	_router:any;

	record_empty:number =0;

  record_offset:number = 0;
	

	token:any='';

  templateGroupList = [];

  searchTxt:string = '';

  per_page:number=10;

  loader_image:boolean =false

  notification:any=[];

  countryList=[];
  country= [
    {key:'Australia',value:'Australia'},
    {key:'Austria',value:'Austria'},
    {key:'Bahrain',value:'Bahrain'},
    {key:'Belgium',value:'Belgium'},
    {key:'Bosnia & Herzegovina',value:'Bosnia & Herzegovina'},
    {key:'Bulgaria',value:'Bulgaria'},
    {key:'Canada',value:'Canada'},
    {key:'Croatia',value:'Croatia'},
    {key:'Cyprus',value:'Cyprus'},
    {key:'Czech Republic',value:'Czech Republic'},
    {key:'Denmark',value:'Denmark'},
    {key:'Estonia',value:'Estonia'},
    {key:'Finland',value:'Finland'},
    {key:'France',value:'France'},
    {key:'Germany',value:'Germany'},
    {key:'Greece',value:'Greece'},
    {key:'Hungary',value:'Hungary'},
    {key:'Iceland',value:'Iceland'},
    {key:'India',value:'India'},
    {key:'Ireland',value:'Ireland'},
    {key:'Israel',value:'Israel'},
    {key:'Italy',value:'Italy'},
    {key:'Japan',value:'Japan'},
    {key:'Latvia',value:'Latvia'},
    {key:'Lithuania',value:'Lithuania'},
    {key:'Luxembourg',value:'Luxembourg'},
    {key:'Macedonia',value:'Macedonia'},
    {key:'Malaysia',value:'Malaysia'},
    {key:'Malta',value:'Malta'},
    {key:'Moldova',value:'Moldova'},
    {key:'Netherlands',value:'Netherlands'},
    {key:'New Zealand',value:'New Zealand'},
    {key:'Norway',value:'Norway'},
    {key:'Palestine',value:'Palestine'},
    {key:'Phillipines',value:'Phillipines'},
    {key:'Poland',value:'Poland'},
    {key:'Portugal',value:'Portugal'},
    {key:'Qatar',value:'Qatar'},
    {key:'Montenegro',value:'Montenegro'},
    {key:'Serbia',value:'Serbia'},
    {key:'Romania',value:'Romania'},
    {key:'Russia',value:'Russia'},
    {key:'Saudi Arabia',value:'Saudi Arabia'},
    {key:'Slovakia',value:'Slovakia'},
    {key:'Slovenia',value:'Slovenia'},
    {key:'South Africa',value:'South Africa'},
    {key:'Spain',value:'Spain'},
    {key:'Sweden',value:'Sweden'},
    {key:'Switzerland',value:'Switzerland'},
    {key:'Thailand',value:'Thailand'},
    {key:'Turkey',value:'Turkey'},
    {key:'Ukraine',value:'Ukraine'},
    {key:'United Arab Erimates',value:'United Arab Erimates'},
    {key:'United Kingdom',value:'UK'},
    {key:'United States of America',value:'United States of America'}
    
    ];
    
  selectedCountry = [];
  oldSelectedCountry=[]
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  role:any=[];
  roleList:any=[];
  selectedRole:any=[]
  userId:any;
  isMshow:boolean=false
  isMasquerade:boolean=false
  text:any=''

  @HostBinding('style.width') public width: string = '100%'; //for edge browser design issue
  countryErr: string='';
  roleErr: string='';

  constructor(msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService, private homeservice:HomeService ) { 
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;
  }

  ngOnInit() {

    this.dropdownSettings2 = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
      closeDropDownOnSelection:true
    };

    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

     let arr=[]
    this.country.map((x)=>{
      let obj={}
      obj['key']=x.key.toUpperCase()
      obj['value']= x.value
      arr.push(obj)
    })
    this.countryList=arr

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      this.token=tokenA.token

      this.homeservice.homeData(tokenA.token).subscribe( (res)=>{

        if(res.status=='success'){
          
          this.loader_image =false
          this.userName=res.user.name;
          this.userId=res.user.id
  
          this.navigationsType=res.navigation;
  
          this.notification =res.notification;
          this.role =res.role[0];
          if(this.role.toLowerCase()=='admin'){
            this.roleList = [
               {key:'PUBLISHER',value:'Publisher'},
               {key:'REVIEWER',value:'Reviewer'},
               {key:'EDITOR',value:'Editor'},
               {key:'USER',value:'User'},
            ]
          }else if(this.role.toLowerCase()=='publisher'){
            this.roleList = [
               {key:'REVIEWER',value:'Reviewer'},
               {key:'EDITOR',value:'Editor'},
               {key:'USER',value:'User'},
            ]
          }else if(this.role.toLowerCase()=='reviewer'){
            this.roleList = [
               {key:'EDITOR',value:'Editor'},
               {key:'USER',value:'User'},
            ]
          }
          if(this.role.toLowerCase()=='admin' || this.role.toLowerCase()=='publisher' || this.role.toLowerCase()=='reviewer'){
            this.isMshow = true
          }else{
            this.isMshow = false
          }
          this.isMasquerade = res.user.masquerade
          if(this.isMasquerade==true){
            this.text = 'Your are masqueraded as '+this.role
          }else{
            this.text='Edit your role'
          }
          let arr1=[]
          let list= this.countryList.filter( (roleI) => { return roleI.value == res.user.country}); 
          
          list.map((x)=>{
            let data={}
            data['key']= x.key;
            data['value'] = x.value;
            arr1.push(data)
          })
          this.selectedCountry= arr1
          
  
          this.broadcast_menu();
          
        }else{        
          this.toastr.error(res.message, '', {timeOut: 3000});
        }
      });
    }catch(error){

      this._router.navigate(['/vlogin']);

    }

  }

  
  
  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   }

  onCountrySelect($event){
       this.countryErr = ''
  }

  onCountrySelectAll($event){

  }

  onCountryDeSelect($event){

  }

  onCountryDeSelectAll($event){

  }

  onRoleSelect($event){
    this.roleErr =''
  }
  onRoleDeSelect($event){

  }

  update(){

    if(this.selectedRole.length==0){

      this.roleErr="Please select a role"

    }else if(this.selectedCountry.length==0){
      this.countryErr="Please select a country"
    }else{

    
      this.loader_image =true
      let country=[],role=[]
      this.selectedRole.map((x)=>{
        role.push(x.value.toLowerCase())
      })
      this.selectedCountry.map((x)=>{
        country.push(x.value)
      })
      let obj={
        token: this.token,
        reqData:{
          uid:this.userId,
          country:this.selectedCountry[0]['value'],
          role:role,
          page:'profile'
        }
      }
      // console.log('update',obj)
      this.homeservice.masquerade(obj).subscribe( (res)=>{
        // console.log('rrrrrrr',res)
        if(res.status=='success'){
          
          this.loader_image =false
          this.userName=res.user.name;
          this.userId=res.user.id

          this.navigationsType=res.navigation;

          this.notification =res.notification;
          this.selectedRole = []
          this.selectedCountry = []
          
          this.broadcast_menu();
          this._router.navigate(['/home']);  
          
        }else{  
          this.loader_image =false      
          this.toastr.error(res.message, '', {timeOut: 3000});
        }
      });
    }
  }
  reset(){
    this.loader_image =true
    let obj={
      token: this.token,
      reqData:{
        uid:this.userId,
        reset:true,
        page:'profile'
      }
    }
    // console.log('update',obj)
    this.homeservice.masquerade(obj).subscribe( (res)=>{
      // console.log('rrrrrrr',res)
      this.loader_image = false
      if(res.status=='success'){
        
       
        this.userName=res.user.name;
        this.userId=res.user.id

        this.navigationsType=res.navigation;

        this.notification =res.notification;

        this.role =res.role[0];
          if(this.role.toLowerCase()=='admin'){
            this.roleList = [
               {key:'PUBLISHER',value:'Publisher'},
               {key:'REVIEWER',value:'Reviewer'},
               {key:'EDITOR',value:'Editor'},
               {key:'USER',value:'User'},
            ]
          }else if(this.role.toLowerCase()=='publisher'){
            this.roleList = [
               {key:'REVIEWER',value:'Reviewer'},
               {key:'EDITOR',value:'Editor'},
               {key:'USER',value:'User'},
            ]
          }else if(this.role.toLowerCase()=='reviewer'){
            this.roleList = [
               {key:'EDITOR',value:'Editor'},
               {key:'USER',value:'User'},
            ]
          }

        this.isMasquerade = res.user.masquerade
          if(this.isMasquerade==true){
            this.text = 'Your are masqueraded as '+this.role
          }else{
            this.text='Edit your role'
          }
          if(this.role.toLowerCase()=='admin' || this.role.toLowerCase()=='publisher' || this.role.toLowerCase()=='reviewer'){
            this.isMshow = true
          }else{
            this.isMshow = false
          }
        
        this.broadcast_menu();
        this._router.navigate(['/home']);  
        
      }else{  
        this.loader_image = false  
        this.toastr.error(res.message, '', {timeOut: 3000});
      }
    });
  }


}
